// extracted by mini-css-extract-plugin
export default {"root":"UpcomingClassesTable_root__YH6us"};